<template>
  <div class="pullOut">
    <new-task-modal
      class="output-modal"
      :newModalVisible="outputModal"
      @closeNewTask="closeOutPut"
      :isDisabled="total == 0"
      @addNewTask="daochu"
      agreeBtn="导出"
      modalTitle="批量导出"
    >
      <div slot="content" style="text-align: left">
        <el-form
          :model="ruleFormOutPut"
          :rules="rulesOutPut"
          ref="ruleFormOut"
          label-width="86px"
          :show-message="false"
          :validate-on-rule-change="false"
          @validate="validateValue"
        >
          <el-form-item label="文件名称" prop="jbDesc">
            <el-input class="output-input" :maxlength="30" placeholder="请输入" v-model.trim="ruleFormOutPut.jbDesc"></el-input>
          </el-form-item>
          <el-form-item label="数据范围" style="display: inherit;">
            <el-radio-group
              v-model="ruleFormOutPut.gzRadio"
              class="output-radio"
              @change="chickRadio(ruleFormOutPut.gzRadio)"
            >
              <el-radio :label="1" v-if="isAll">全部数据</el-radio>
              <el-radio v-if="isJS" :label="2">当前检索条件下的数据</el-radio>
              <el-radio v-if="isGX" :label="3">勾选数据</el-radio>
            </el-radio-group>
            <div class="output-notice" style="padding-top:0;">共计{{total}}条数据</div>
          </el-form-item>
          <el-form-item :label="LBName+'信息'" prop="fieldGroup">
            <el-checkbox
              :indeterminate="isIndeterminate"
              v-model="ruleFormOutPut.checkAll"
              @change="handleCheckAllChange"
            >全部</el-checkbox>
            <el-checkbox-group
              v-model="ruleFormOutPut.fieldGroup"
              @change="handleCheckedCitiesChange"
            >
              <el-checkbox
                v-for="(item, index) in fieldArr"
                :label="item.id"
                :key="index"
                :title="item.label"
              >{{item.label.length > 5 ? item.label.slice(0, 5) + '...' : item.label}}</el-checkbox>
            </el-checkbox-group>
          </el-form-item>
          <!-- <el-form-item class="output-group">
            <el-checkbox-group
              v-model="ruleFormOutPut.fieldGroup"
              @change="handleCheckedCitiesChange"
            >
              <el-checkbox
                v-for="(item, index) in fieldArr"
                :label="item.id"
                :key="index"
              >{{item.label.length > 5 ? item.label.slice(0, 5) + '...' : item.label}}</el-checkbox>
            </el-checkbox-group>
          </el-form-item> -->
          <div class="output-notice">提示：导出数据请控制在<span style="color: rgb(255, 77, 79)">1万</span>条数据以内，否则可能会出现导出失败或系统卡顿</div>
        </el-form>
      </div>
    </new-task-modal>
    <new-task-modal
      :showModalClose='false'
      class="output-modal"
      :closeonclickmodal="closeonclickmodal"
      :newModalVisible="daochuGuoCModal"
      @addNewTask="isdaochuGuoC"
      @closeNewTask="isdaochuGuoC"
      :isOneBtn="OnlyBtn"
      :isDisabled="guanbiDisabled"
      agreeBtn="关闭"
      :modalTitle="daochuTitle"
    >
      <div slot="content" style="text-align: left">
        <div class="daoru-addnew">
          <span>耗时 :</span>
          <span>{{DaochuSuccese.Time}}</span>
          <span v-if="DaochuSuccese.tryMathRemainTime">剩余时间:{{DaochuSuccese.tryMathRemainTime}}</span>
           <span
            v-if="downloadUrl"
            style="color:#2D8CF0;cursor: pointer;"
            @click="downloadFile(downloadUrl)"
          >点击下载</span>
        </div>
        <div class="daoru-addnew" v-if="!DaochuSuccese.finished">
          <span style="color: #FF4D4F;">正在操作，请耐心等待，若操作意外中断，数据仍将继续导出。</span>
        </div>
        <!--  -->
        <div class="daoru-addnew" v-if="DaochuSuccese.finished && DaochuSuccese.errorMsg">
          <!-- <el-tooltip popper-class='tooltip' class="item" :content="DaochuSuccese.errorMsg" placement="top"> -->
            <div @click="open(DaochuSuccese.errorMsg)" class="errorMsg">{{DaochuSuccese.errorMsg}}</div>
          <!-- </el-tooltip> -->
        </div>
        <div class="daoru-addnew daoru-progress">
          <el-progress :percentage="percenNum"></el-progress>
        </div>
        <div class="daoru-caozuoshuju">
          <span v-if="DaochuSuccese.totalNum >= 0">{{DaochuSuccese.finishNum + '/' +  DaochuSuccese.totalNum}}</span>
          <span v-if="DaochuSuccese.redisKey">{{'导出编号:' +  DaochuSuccese.redisKey}}</span>
        </div>
      </div>
    </new-task-modal>
  </div>
</template>

<script>
import { daochuSelectBT, daochuSelectBTPost, toDaoRuData } from "@/api/Daoru/daoru";
import { mapState } from "vuex";
export default {
  props: {
    currentChooseData: {
      type: Number,
      default: 0
    },
    isAll: {
      type: Boolean,
      default: true
    },
    // 导出弹窗
    outputModal: {
      type: Boolean,
      default: false
    },
    //是否有检索条件
    isJS: {
      type: Boolean,
      default: false
    },
    //是否有勾选数据
    isGX: {
      type: Boolean,
      default: true
    },
    //是否是班级的导出
    isBJ: {
      type: Boolean,
      default: false
    },
    //字段接口链接
    biaotouURL: {
      type: String
    },
    //导出接口链接
    daochuURL: {
      type: String
    },
    // 导出时候的检所条件
    requestModel: {
      type: Object,
      default: ()=> {
        return {}
      }
    },
    //导出勾选数据
    checkID: {
      type: String,
      default: ""
    },
    //导出勾选数组
    checkArr: {
      type: Array,
      default: null
    },
    //导出文件列表数据名称
    LBName: {
      type: String
    },
    //获取可选的导出字段
    pullOutDate: {
      type: Object,
      default: null
    },
    isformInline: {
       type: Boolean,
      default: false
    },
    // 导出类型
    pullType: {
      type: Object,
      default: null
    },
    //数据筛选
    hignSearchRes: {
      type: String,
      default: ""
    },
    //是否需要内层参数
    isHignSearchRes: {
      type: Boolean,
      default: false
    },
    //获取导出总条数接口
    ExportCountURL: {
      type: String
    },
    //获取导出总条数接口
    lunxun: {
      type: String
    },
    //身份
    identity: {
      type: String,
      default: ""
    },
  },
  data() {
    return {
      downloadUrl: "", //下载地址
      isTS: "导出未完成", //导出弹框提示文字
      daochuTitle: '导出', //导出过程定时器
      daochuTimer: null, //导出过程定时器
      IsDaochuTimes: 0, //导出过程定时器
      percenNum: 0, //进度条进度数字
      DaochuSuccese: {
        errorData: [], //错误数据  暂存前端 下载错误数据时返回
        finished: false, // 是否完成导出
        Time: "导出中", //耗时
        totalNum: 0, // 总计需要操作次数
        finishNum: 0, // 当前操作次数
        jumpNum: 0, // 跳过数量
        errorKey: "" //错误数据
      }, //导出成功后的数据列表
      guanbiDisabled: true, //导出过程弹框关闭按钮
      OnlyBtn: true, //导出过程弹框只有一个按钮
      daochuGuoCModal: false, //导出过程弹窗
      closeonclickmodal: false, //是否开启点击空白处关闭弹窗
      isIndeterminate: false,
      //导出表单绑定
      ruleFormOutPut: {
        checkAll: true, // 全选
        // checkAll: false, // 全选
        jbDesc: "",
        gzRadio: 1, // 数据范围
        fieldGroup: [] // 表头字段
      },
      //导出表单验证
      rulesOutPut: {
        jbDesc: [{ required: true, message: "请输入文件名称", trigger: "blur" }],
        fieldGroup: [{
          type: 'array', required: true, message: "请至少选择一个导出字段", trigger: "change"
        }]
      },
      //
      fieldArr: [],
      uplodeDate: {}, //传入的参数
      total: "", //导出总条数
      countNum: 1, //用于显示第一个错误
      redisKey: '', //用于显示第一个错误
    };
  },
  watch: {
    outputModal: function() {
      // let qx = true;
      console.log("看一看chickID", this.checkID);
      console.log("看看ruleFormOutPut", this.ruleFormOutPut);
      if (this.outputModal) {
        this.fieldArr = [];
        if (this.pullOutDate !== null) {
          this.uplodeDate = this.pullOutDate;
          this.selectBT();
          // this.handleCheckAllChange(qx);
          if (this.outputModal) {
            this.setName();
            this.selectTotal();
          }
        } else {
          this.selectBT();
          // this.handleCheckAllChange(qx);
          if (this.outputModal) {
            this.setName();
            this.selectTotal();
          }
        }
      }
    }
  },
  created() {
    // this.selectBT();
  },
  methods: {
    open(txt) {
      this.$alert(txt, '错误信息', {
        confirmButtonText: '关闭',
        customClass:'msgCard',
        callback: () => {
        }
      });
    },
    closeAll () {
      this.ruleFormImport.fieldGroup = [];
      this.ruleFormOutPut.fieldGroup = [];
      this.fieldArr = [];
      this.$emit("closeNewTask");
      this.detailModal = false;
      this.outputModal = false;
      clearInterval(this.daochuTimer);
      this.daochuTimer = null;
      this.$refs.ruleFormOut && this.$refs.ruleFormOut.resetFields();
      this.fieldArr = [];
      this.DaochuSuccese = {
        errorData: [], //错误数据  暂存前端 下载错误数据时返回
        Time: "导出中" //耗时
      };
      this.percenNum = 0;
      this.daochuGuoCModal = false;
      //开启定时器
      // this.getTime();
    },
    //关闭导出过程弹框
    isdaochuGuoC () {
      console.log(1111111)
      clearInterval(this.daochuTimer);
      this.daochuTimer = null;
      this.$refs.ruleFormOut.resetFields();
      this.fieldArr = [];
      this.downloadUrl = ''
      this.DaochuSuccese = {
        errorData: [], //错误数据  暂存前端 下载错误数据时返回
        Time: "导出中" //耗时
      };
      this.percenNum = 0;
      this.daochuGuoCModal = false;
      this.guanbiDisabled = true;
      this.$emit("daoruSuccess");
    },
    //给文件名默认值
    setName() {
      let date = new Date();
      let Y = date.getFullYear();
      let IsY = Y.toString();
      console.log("YYYYYY", Y);
      let M =
        date.getMonth() + 1 < 10
          ? "0" + (date.getMonth() + 1)
          : date.getMonth() + 1;
      let IsM = M.toString();
      let D = date.getDate() < 10 ? "0" + date.getDate() : date.getDate();
      let IsD = D.toString();
      let hh = date.getHours() < 10 ? "0" + date.getHours() : date.getHours();
      let Ishh = hh.toString();
      let mm =
        date.getMinutes() < 10 ? "0" + date.getMinutes() : date.getMinutes();
      let Ismm = mm.toString();
      let ss =
        date.getSeconds() < 10 ? "0" + date.getDate() : date.getSeconds();
      let Isss = ss.toString();
      let nowData = IsY + IsM + IsD + Ishh + Ismm + Isss;
      console.log("当前时间", nowData);
      this.ruleFormOutPut.jbDesc = `没有照片的${this.LBName}${nowData}`;
      console.log("当前时间的文件名", this.ruleFormOutPut.jbDesc);
    },
    // 取消导入
    closeOutPut() {
      this.countNum = 1
      this.ruleFormOutPut = {
        checkAll: true, // 全选
        // checkAll: false, // 全选
        jbDesc: "",
        gzRadio: 1, // 数据范围
        fieldGroup: [] // 表头字段
      };
      this.fieldArr = [];
      this.ruleFormOutPut.checkAll = true;
      this.ruleFormOutPut.jbDesc = "";
      this.ruleFormOutPut.gzRadio = 1;
      this.ruleFormOutPut.fieldGroup = [];
      console.log("取消导入", this.ruleFormOutPut);
      this.isIndeterminate = false;
      this.total = 0
      this.$emit("closeNewTask");
    },
    // 全选变化
    handleCheckAllChange(val) {
      // console.log("全选变化", val);
      // this.ruleFormOutPut.fieldGroup = val ? this.fieldArr : [];
      this.ruleFormOutPut.fieldGroup = [];
      if (val) {
        this.fieldArr.forEach(row => {
          this.ruleFormOutPut.fieldGroup.push(row.id);
        });
      } else {
        this.ruleFormOutPut.fieldGroup = [];
      }
      // console.log(this.ruleFormOutPut.fieldGroup);
      this.isIndeterminate = false;
    },
    // 多个选中变化
    handleCheckedCitiesChange(value) {
      console.log(value);
      let checkedCount = value.length;
      if (checkedCount === this.fieldArr.length) {
        this.ruleFormOutPut.checkAll = true;
      }
      this.isIndeterminate =
        checkedCount > 0 && checkedCount < this.fieldArr.length;
      if (checkedCount === 0) {
        this.ruleFormOutPut.checkAll = false;
      }
    },
    //获取表头字段
    selectBT() {
      try {
        const url = this.biaotouURL;
        console.log("urlllll", url);
        if (this.pullOutDate !== null) {
          let params = {
            tenantId: this.userInfo.tenant_id,
            id: this.uplodeDate.id
          };
          daochuSelectBTPost(url, params).then(res => {
            const data = res.data.result;
            var KeyList = Object.keys(data);
            KeyList.forEach(row => {
              var ZD = {
                id: data[row] + ":" + row,
                label: data[row]
              };
              // var ZD = {
              //   id: row,
              //   label: data[row]
              // };
              this.fieldArr.push(ZD);
              let qx = true;
              this.handleCheckAllChange(qx);
            });
            console.log("导出获取表头字段", this.fieldArr);
          });
        } else if (this.identity) {
            let params = {
            tenantId: this.userInfo.tenant_id,
            identity:this.identity
          };
          daochuSelectBTPost(url, params).then(res => {
            const data = res.data.result;
            var KeyList = Object.keys(data);
            KeyList.forEach(row => {
              var ZD = {
                id: data[row] + ":" + row,
                label: data[row]
              };
              // var ZD = {
              //   id: row,
              //   label: data[row]
              // };
              this.fieldArr.push(ZD);
              let qx = true;
              this.handleCheckAllChange(qx);
            });
            console.log("导出获取表头字段", this.fieldArr);
          });
        } else {
          daochuSelectBT(url).then(res => {
            const data = res.data.result;
            var KeyList = Object.keys(data);
            KeyList.forEach(row => {
              var ZD = {
                id: data[row] + ":" + row,
                label: data[row]
              };
              // var ZD = {
              //   id: row,
              //   label: data[row]
              // };
              this.fieldArr.push(ZD);
              let qx = true;
              this.handleCheckAllChange(qx);
            });
            console.log("导出获取表头字段", this.fieldArr);
          });
        }
      } catch (err) {
        console.log(err);
      }
    },
    // 验证
    validateValue(prop, msgStatus, validateMessage) {
      // if (validateMessage) {
      //   this.$message.error(validateMessage);
      // }
      if (!this.countNum && !msgStatus) {
        this.countNum += 1;
        if (validateMessage) {
          this.$message.error(validateMessage);
        }
      }
    },
    //导出数据
    daochu() {
      try {
        this.countNum = 0;
        this.$refs.ruleFormOut.validate(valid => {
          console.log("valid", valid);
          if (valid) {
            this.countNum = 1
            const url = this.daochuURL;
            console.log("urlllll", url);
            var exportFieldList = this.ruleFormOutPut.fieldGroup.join(",");
            // console.log("aaaaaaaa",exportFieldList)
            let params = {
              tenantId: this.userInfo.tenant_id, //租户id
              fileName: this.ruleFormOutPut.jbDesc, //文件名称
              dataRange: this.ruleFormOutPut.gzRadio, //数据范围 传 1 全部数据  2 检索条件下的数据  3 勾选数据
              exportField: exportFieldList, //导出字段  未选择时传"",则导出全部字段 驼峰
              choiceDataIds: this.checkID //勾选的数据的ids  唯一uuid  用，隔开
            };
            console.log("urlllll", params);
            if (this.isJS) {
              if (this.pullOutDate !== null) {
                params = {
                  advancedSearch: this.hignSearchRes, //数据筛选
                  tenantId: this.userInfo.tenant_id, //租户id
                  id: this.uplodeDate.id, //表id
                  fileName: this.ruleFormOutPut.jbDesc, //文件名称
                  dataRange: this.ruleFormOutPut.gzRadio, //数据范围 传 1 全部数据  2 检索条件下的数据  3 勾选数据
                  exportField: exportFieldList, //导出字段  未选择时传"",则导出全部字段 驼峰
                  choiceDataList: this.checkArr //勾选的数据的ids  唯一uuid  用，隔开
                };
              } else {
                params = {
                  type: this.pullType ? this.pullType.type : null,
                  formInline: this.requestModel,
                  advancedSearch: this.hignSearchRes, //数据筛选
                  tenantId: this.userInfo.tenant_id, //租户id
                  fileName: this.ruleFormOutPut.jbDesc, //文件名称
                  dataRange: this.ruleFormOutPut.gzRadio, //数据范围 传 1 全部数据  2 检索条件下的数据  3 勾选数据
                  exportField: exportFieldList, //导出字段  未选择时传"",则导出全部字段 驼峰
                  choiceDataIds: this.checkID //勾选的数据的ids  唯一uuid  用，隔开
                };
              }
              // params = Object.assign(params, this.requestModel);
              console.log("看看params", params);
            }
            if (this.isBJ) {
              let Form = {
                tenantId: this.userInfo.tenant_id, //租户id
                className: this.requestModel.className, //班级名称
                grade: this.requestModel.grade, //所属年级
                monitor: this.requestModel.monitor, //班长
                status: this.requestModel.status, //状态（1开启，0关闭）
                dataFrom: this.requestModel.dataFrom //数据来源（1自建，2同步）
              };
              params = {
                formInline: Form,
                advancedSearch: this.hignSearchRes, //数据筛选
                collegeId: this.requestModel.collegeId, //院系代码id
                majorId: this.requestModel.majorId, //专业代码id
                classTeacherTypeEqualsOneName: this.requestModel
                  .classTeacherTypeEqualsOneName, //输入的辅导员姓名
                classTeacherTypeEqualsTwoName: this.requestModel
                  .classTeacherTypeEqualsTwoName, //输入的班主任姓名
                tenantId: this.userInfo.tenant_id, //租户id
                fileName: this.ruleFormOutPut.jbDesc, //文件名称
                dataRange: this.ruleFormOutPut.gzRadio, //数据范围 传 1 全部数据  2 检索条件下的数据  3 勾选数据
                exportField: exportFieldList, //导出字段  未选择时传"",则导出全部字段 驼峰
                choiceDataIds: this.checkID //勾选的数据的ids  唯一uuid  用，隔开
              };
            }
            if (this.identity) {
                params.identity=this.identity
                // params.fileName=`没有照片的${this.LBName}`
            }
            console.log("看看params", params);
            daochuSelectBTPost(url, params).then(res => {
              console.log("看一看拿到了什么", res);
              const data = res.data;
              if (data.status == 1000) {
                console.log(1);
                this.redisKey = data.result.redisKey;
                this.closeOutPut();
                this.daochuGuoCModal = true
                clearInterval(this.daochuTimer);
                this.daochuTimer = null;
                this.IsDaochuTimes = 0;
                //开启定时器
                this.getTime()
              } else if (data.status === 1002) {
                this.$message.error(data.msg);
                this.closeOutPut();
                //清空定时器
                clearInterval(this.daochuTimer);
                this.daochuTimer = null;
                this.IsDaochuTimes = 0;
              } else {
                // debugger
                this.guanbiDisabled = false;
                this.$message.error(data.msg);
              }
            });
            this.daochuGuoCModal = true
            this.closeOutPut();
          } else {
            return false;
          }
        });
      } catch (err) {
        console.log(err);
      }
    },
    //查询导出状况定时器
    getTime () {
      this.daochuTimer = setInterval(() => {
        this.IsDaochuTimes = this.IsDaochuTimes + 3;
        this.daoruIng();
      }, 3000);
    },
    //轮询状态请求查询导出状况
    daoruIng() {
      // debugger
      try {
        const url = this.lunxun;
        console.log("urlllll", url);
        let params = {};
        params = {
          tenantId: this.userInfo.tenant_id,
          redisKey: this.redisKey
        };
        if (this.identity) {
            params.identity=this.identity
        }
        toDaoRuData(url, params).then(res => {
          const data = res.data;
          console.log("这是轮询状态请求查询导出状况接口", data);
          if (data.status === 1000) {
            // 没有结果的情况
            if (data.result === "null") {
              return
            }
            // 没有完成导出的情况
            let asyncTask = data.result
            this.percenNum = new Number((asyncTask.finishRate * 100).toFixed(2))
            this.DaochuSuccese = Object.assign(this.DaochuSuccese,asyncTask)
            // 没有结束的时候 时间需要手动计算
            // this.DaochuSuccese.Time = ((new Date() - new Date(asyncTask.startTime))/1000).toFixed(2)
            if (asyncTask.useTimeStr) {
              this.DaochuSuccese.Time = asyncTask.useTimeStr
            }
            if (asyncTask.finished == true) {
              clearInterval(this.daochuTimer);
              this.daochuTimer = null;
              // this.DaochuSuccese.Time = asyncTask.useTime;
              console.log("DaochuSuccese", this.DaochuSuccese);
              this.IsDaochuTimes = 0;
              this.percenNum = 100;
              this.guanbiDisabled = false;
              this.isTS = "导出完成";
              if (asyncTask.result.url) {
                this.downloadUrl = asyncTask.result.url
                this.downloadFile(asyncTask.result.url)
              }
              if (this.isTS !== "导出完成") {
                this.$message.error(this.isTS);
              } else {
                this.$message.success(this.isTS);
              }
            }
          } else if (data.status === 8010) {
            // 网络超时终端，不进行处理
            return
          } else {
            this.daochuTitle = '导出失败'
            console.error('导出情况获取失败 导出数据：' + JSON.stringify(data))
            clearInterval(this.daochuTimer);
            this.daochuTimer = null;
            this.isTS = "操作失败";
            if (this.isTS !== "导出完成") {
              this.$message.error(this.isTS);
            } else {
              this.$message.success(this.isTS);
            }
            this.guanbiDisabled = false;
            // this.isdaochuGuoC();
          }
        });
      } catch (err) {
        console.log(err);
      }
    },
    downloadFile(url){
      const a = document.createElement('a')
      a.href = url
      a.download = decodeURIComponent(this.ruleFormOutPut.jbDesc)
      document.body.appendChild(a)
      a.click()
      URL.revokeObjectURL(a.href)
      document.body.removeChild(a)
      // this.outputModal = false
    },
    //下载文件
    download(data, fileName, fileType) {
      if (!data) {
        return;
      }
      var blob = new Blob([data], {
        type: fileType ? fileType : "application/vnd.ms-excel"
      });
      var url = window.URL.createObjectURL(blob);
      var aLink = document.createElement("a");
      aLink.style.display = "none";
      aLink.href = url;
      aLink.setAttribute(
        "download",
        fileName ? fileName : new Date().getTime()
      );
      document.body.appendChild(aLink);
      aLink.click();
      document.body.removeChild(aLink); //下载完成移除元素
      window.URL.revokeObjectURL(url); //释放掉blob对象
    },
    //获取导出数据总条数
    selectTotal() {
      try {
        const url = this.ExportCountURL;
        console.log("urlllllllll", url);
        let params = {};
        if (this.pullOutDate !== null) {
          let advancedSearch = "";
          if (this.ruleFormOutPut.gzRadio == 2) {
            advancedSearch = this.hignSearchRes;
          }
          params = {
            id: this.uplodeDate.id, //表id
            tenantId: this.userInfo.tenant_id,
            advancedSearch: advancedSearch //检索条件
          };
        } else {
          let formInline = {};
          formInline = this.requestModel;
          if (this.isHignSearchRes) {
            formInline.advancedSearch = this.hignSearchRes
          }
          if (this.ruleFormOutPut.gzRadio == 2) {
            if (this.isBJ) {
              formInline = {
                //检索条件
                // eduClassInfo: {
                  //班级信息
                tenantId: this.userInfo.tenant_id, //租户id
                className: this.requestModel.className, //班级名
                grade: this.requestModel.grade, //年级
                monitor: this.requestModel.monitor, //班长
                status: this.requestModel.status, //状态
                dataFrom: this.requestModel.dataFrom, //数据来源
                // },
                collegeId: this.requestModel.collegeId, //院系id
                majorId: this.requestModel.majorId, //专业id
                classTeacherTypeEqualsOneName: this.requestModel
                  .classTeacherTypeEqualsOneName, //辅导员
                classTeacherTypeEqualsTwoName: this.requestModel
                  .classTeacherTypeEqualsTwoName //班主任
              };
              if (this.isHignSearchRes) {
                formInline.advancedSearch = this.hignSearchRes
              }
            }
          }
          params = {
            // hignSearchRes:this.hignSearchRes,
            tenantId: this.userInfo.tenant_id,
            formInline: formInline
          };
          if (this.identity) {
              params.identity=this.identity,
              params.fileName= this.ruleFormOutPut.jbDesc, //文件名称
              params.exportField= '' //导出字段
          }
        }
        params.advancedSearch = this.hignSearchRes //数据范围 传 1 全部数据  2 检索条件下的数据  3 勾选数据
        params.dataRange = this.ruleFormOutPut.gzRadio //数据范围 传 1 全部数据  2 检索条件下的数据  3 勾选数据
        // debugger
        daochuSelectBTPost(url, params).then(res => {
          console.log("看一看拿到了什么", res);
          const data = res.data;
          if (data.status == 1000) {
            this.total = data.result;
            console.log("现在的总条数", this.total);
          }
        });
      } catch (err) {
        console.log(err);
      }
    },
    //点击更换导出数据范围
    chickRadio(val) {
      if (val == 3) {
        if (this.checkArr !== null) {
          console.log("点击数据范围", this.checkArr.length);
          this.total = this.checkArr.length;
        } else {
          if (this.checkID == "") {
            this.total = 0;
          } else {
            let chickIdArr = this.checkID.split(",");
            this.total = chickIdArr.length;
            console.log("看看勾选ID长度", chickIdArr);
          }
        }
      } else {
        console.log("点击数据范围");
        this.selectTotal();
      }
    }
  },
  computed: {
    ...mapState({
      userInfo: state => state.user.userInfo
    })
  },
  mounted() {
    if(this.currentChooseData!==0) {
      this.ruleFormOutPut.gzRadio = this.currentChooseData
    }
  }
};
</script>

<style lang="scss">
.msgCard {
  .el-message-box__message{
    p{
      word-break:break-all
    }
  }
}
.pullOut {
  .new-task-modal .el-dialog__body .el-form-item {
    display: block;
  }
   .daoru-addnew {
    height: 28px;
    line-height: 28px;
    margin-top: 16px;
    span {
      margin-right: 8px;
    }
  }
  .daoru-progress {
    .el-progress-bar {
      padding-right:65px;
      margin-right:-65px;
    }
  }
  .errorMsg{
    color: rgb(255, 77, 79);
    font-size: 12px;
    line-height: 18px;
    overflow: hidden;
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
  }
  .daoru-caozuoshuju {
    height: 12px;
    line-height: 12px;
    font-size: 12px;
    color: #aeaeb4;
    span {
      margin-right: 8px;
    }
  }
}
</style>
